import { FOCUS_TRAP_SELECTOR } from '../constants';
const handleClickOutside = ({ event, current, onEscape }) => {
    const dialogs = document.querySelectorAll(FOCUS_TRAP_SELECTOR);
    const isCurrentActiveDialog = dialogs[dialogs.length - 1] === current;
    if (isCurrentActiveDialog &&
        event.target &&
        !dialogs[dialogs.length - 1].contains(event.target)) {
        onEscape();
    }
};
export default handleClickOutside;
//# sourceMappingURL=handleClickOutside.js.map